// removed by extract-text-webpack-plugin
module.exports = {"menu":"settings-menus__menu___3fxYZ","active-menu-item":"settings-menus__active-menu-item___C4zwo"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/settings-menus.scss
// module id = 520
// module chunks = 0